import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function Includes() {
  const { t } = useTranslation();

  const items = [
    { icon: 'ri-vidicon-line', text: t('phoenix.includes1') },
    { icon: 'ri-time-line', text: t('phoenix.includes2') },
    { icon: 'ri-store-2-line', text: t('phoenix.includes3') },
    { icon: 'ri-search-eye-line', text: t('phoenix.includes4') },
    { icon: 'ri-message-2-line', text: t('phoenix.includes5') },
    { icon: 'ri-download-2-line', text: t('phoenix.includes6') },
    { icon: 'ri-file-text-line', text: t('phoenix.includes7') },
    { icon: 'ri-stack-line', text: t('phoenix.includes8') },
  ];

  return (
    <section className="relative py-20 md:py-28 bg-white">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <ScrollReveal direction="up">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-50 border border-accent-200/50 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
            {t('phoenix.includesTag')}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-16">
            Todo lo que necesitas para <span className="text-primary-500">transformar tu negocio.</span>
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {items.map((item, i) => (
            <ScrollReveal key={i} direction="up" delay={i * 0.06}>
              <div className="group flex items-center gap-4 p-5 rounded-2xl bg-white border border-background-200/70 shadow-[0_2px_8px_rgba(0,0,0,0.02)] hover:shadow-[0_4px_20px_rgba(0,0,0,0.04)] hover:-translate-y-0.5 transition-all duration-300 cursor-default">
                <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center shrink-0 group-hover:bg-primary-100 transition-colors duration-300">
                  <i className={`${item.icon} text-primary-600 text-lg`}></i>
                </div>
                <p className="text-foreground-700 text-sm font-medium leading-snug">{item.text}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}